import { render, staticRenderFns } from "./TranslateDropdown.vue?vue&type=template&id=51ea101c&scoped=true&"
import script from "./TranslateDropdown.vue?vue&type=script&lang=ts&"
export * from "./TranslateDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./TranslateDropdown.vue?vue&type=style&index=0&id=51ea101c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ea101c",
  null
  
)

export default component.exports